import $ from 'jquery';

export default class SortSelect {
	constructor() {
		this.selectBox = $('.sort-select');
		this.select = $('.sort-select_select');
	}

	init() {
		this.selectBox.each(function () {
			$(this).children('select').css('display', 'none');

			const $current = $(this);

			$(this).find('option').each(function (i) {
				if (i === 0) {
					$current.prepend($('<div>', {
						class: $current.attr('class').replace(/sort-select/g, 'sort-select__box')
					}));

					const placeholder = $(this).text();
					$current.prepend($('<span>', {
						class: $current.attr('class').replace(/sort-select/g, 'sort-select__placeholder sort-select__placeholder_gray'),
						text: placeholder
					}));

					return;
				}

				$current.children('div').append($('<span>', {
					class: $current.attr('class').replace(/sort-select/g, 'sort-select__options'),
					text: $(this).text()
				}));
			});
		});

		this.selectBox.click(function () {
			$(this).toggleClass('sort-select_active');
		});

		$('.sort-select__options').on('click', function () {
			const txt = $(this).text();

			$(this).siblings('.sort-select__options').removeClass('sort-select__options_selected');
			$(this).addClass('sort-select__options_selected');

			const currentSel = $(this).closest('.sort-select');
			currentSel.children('.sort-select__placeholder').text(txt);
			currentSel.children('.sort-select__placeholder').removeClass('sort-select__placeholder_gray');
			const op = $('#utility-table');
			if ($(this).text() === 'Сортировать по дате обновления') {
				op.find('th:eq(2)').trigger('sort');
			}else {
				op.find('th:eq(0)').trigger('sort');
			}
		});

	}
}



// WEBPACK FOOTER //
// ./app/blocks/sort-select/index.js